import { Reducer } from 'redux';
import { SiteActionTypes, SiteState } from './types';

export const initialState: SiteState = {
  apps: []
};

const reducer: Reducer<SiteState> = (state = initialState, action: any) => {
  switch (action.type) {
    case SiteActionTypes.GET_SITE_APPS_START: {
      return {
        ...state,
        isLoadingApps: true,
        apps: []
      };
    }
    case SiteActionTypes.GET_SITE_APPS_SUCCESS: {
      return {
        ...state,
        isLoadingApps: false,
        apps: action.payload
      };
    }
    case SiteActionTypes.GET_SITE_APPS_FAILURE: {
      return {
        ...state,
        isLoadingApps: false,
        loadAppError: action.payload
      };
    }
    default:
      return state;
  }
};

export { reducer as SiteReducer };
